import Abstract from './Abstract.js';

export default class Modal extends Abstract {
  constructor(props) {
    super(props);
  }

  addHoverToRow() {
    const { chart, onShowEditMilestone } = this.props;
    const that = this;

    chart.selectAll('.modal-mile').on('click', (d) => {
      onShowEditMilestone(d.childMilestone);
    });
  }

  build() {
    this.addHoverToRow();
  }
}
